import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		defaultMessage: 'Change layout',
		id: 'dashboard-edit.header-editable.change-layout-button.title',
		description: 'Describes the specific role of this popup.',
	},
});
